import request from '../request/http'
import Vue from 'vue'
import { Toast,Dialog } from 'vant'
Vue.use(Toast)
import api from '../request/api'
import router from '../router'

export default {
  /* 微信支付 */
  creatWxPay: function (options,callback,cancel_callback) {
    request({
      url: options.url,
      data: options.data
    }).then((res) => {
      if (res.error === 0) {
          if (res.wechat.success) {
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', function () {
                  onBridgeReady(res.wechat, callback,cancel_callback)
                }, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', function () {
                  onBridgeReady(res.wechat, callback,cancel_callback)
                });
                document.attachEvent('onWeixinJSBridgeReady', function () {
                  onBridgeReady(res.wechat, callback,cancel_callback)
                });
              }
            } else {
              onBridgeReady(res.wechat, callback,cancel_callback);
            }
          }
      }

    }).catch((err) => {
      // Toast('系统异常！')
    });

  },
 
  /* 微信分享 */
  creatWxShare: function (options) {
    var showToast = options.toast || 'show'
    request({
      url: api.requestApi.index.share_url,
      data: {
        url: window.location.href.split('#')[0]
      }
    }).then(function (res) {
      var shareMsg = res.jssdkconfig
      wx.config({
        //debug: true, //生产环境需要关闭debug模式
        appId: shareMsg.appId, //appId通过微信服务号后台查看
        timestamp: shareMsg.timestamp, //生成签名的时间戳
        nonceStr: shareMsg.nonceStr, //生成签名的随机字符串
        signature: shareMsg.signature, //签名
        jsApiList: [ //需要调用的JS接口列表
          'updateAppMessageShareData', //分享给好友
          'updateTimelineShareData', //分享到朋友圈
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          "showMenuItems"
        ]
      })

      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ["showMenuItems", "updateAppMessageShareData", "updateTimelineShareData"],
          success: function (res) {
            wx.showMenuItems({
              menuList: [
                'menuItem:share:appMessage', //发送给朋友
                'menuItem:share:timeline' //分享到朋友圈
              ]
            })
          }
        })

        //分享到朋友圈
        wx.updateTimelineShareData({
          title: options.title, // 分享标题
          desc: options.desc, //分享描述
          link: options.link, // 分享链接
          imgUrl: options.imgUrl, // 分享图标
          success: function () {
            if(showToast=='show')Toast('分享链接已生成')
          }
        })

        //分享给朋友
        wx.updateAppMessageShareData({
          title: options.title, // 分享标题
          desc: options.desc, // 分享描述
          link: options.link, // 分享链接
          imgUrl: options.imgUrl, // 分享图标
          success: function () {
            if(showToast=='show')Toast('分享链接已生成')
          }
        })


       wx.ready(function(){
       			// 获取用户当前位置经度纬度
       		wx.getLocation({
       					type: 'wgs84',		// 坐标类型 默认wgs84
       					success:function(result){
       					    //Toast(result.latitude + result.longitude);
       							console.log('已获取地理授权' + result.latitude +"    "+ result.longitude);
       					},
       			cancel: function(res) {
       						alert('您已拒绝地理授权');
       			}
       		});
       		wx.error(function(res) {
       				console.log('地理授权获取失败' + res);
       		});
      })




      })

    }).catch(() => {
      // Toast('系统异常！')
    })
  },

  /* 微信扫一扫 */
  scanQRCode: function (callback) {
    request({
      url: api.requestApi.index.share_url,
      data: {
        url: window.location.href.split('#')[0]
      }
    }).then(function (res) {
      var shareMsg = res.jssdkconfig
      wx.config({
        // debug: true, //生产环境需要关闭debug模式
        appId: shareMsg.appId, //appId通过微信服务号后台查看
        timestamp: shareMsg.timestamp, //生成签名的时间戳
        nonceStr: shareMsg.nonceStr, //生成签名的随机字符串
        signature: shareMsg.signature, //签名
        jsApiList: [ //需要调用的JS接口列表
          "scanQRCode"
        ]
      })
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success:callback
      })
    }).catch(() => {
      // Toast('系统异常！')
    })

  },
   /* 微信地址 */
   getlocation:function(callback,callback_error){

    wx.ready(function(){
      // 获取用户当前位置经度纬度
      wx.getLocation({
        type: 'wgs84',		// 坐标类型 默认wgs84
        success:callback,
        cancel: function(res) {
              alert('您已拒绝地理授权');
        }
      });
      wx.error(callback_error);
    })
  },
}
  

// 调用微信内置js对象 WeixinJSBridge 发起支付
function onBridgeReady(params, callback,cancel_callback) {
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest', {
      "appId": params.appId, //公众号名称，由商户传入
      "timeStamp": params.timeStamp, //时间戳，自1970年以来的秒数
      "nonceStr": params.nonceStr, //随机串
      "package": params.package,
      "signType": params.signType, //微信签名方式：
      "paySign": params.paySign //微信签名
    },
    function (res) {
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。

        callback && callback()

      } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
        cancel_callback && cancel_callback();
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/common/wx-js-sdk.js